import * as yup from 'yup';
import { Quote } from '../../../models/quote.model';

export const quoteInitialValues: Partial<Quote> = {
  status: '',
  date: new Date().toISOString().split('T')[0],
  serviceFormURL: undefined,
  titleZip: '',
  titleState: '',
  county: '',
  city: '',
  transactionType: '',
  collateralType: '',
  outsideCityLimits: false,
  driverLastName: '',
  vinNumber: '',
  commercialUse: 'No',
  modelYear: '',
  make: '',
  bodyStyle: '',
  odometer: '',
  registrationMonths: '',
  weight: '',
  registeredWeight: undefined,
  gvw: undefined,
  gvwr: undefined,
  fuelType: undefined,
  evTaxCredit: 'Do not apply',
  taxCreditAmount: undefined,
  length: undefined,
  activeMilitary: 'No',
  mcoTitle: 'Title',
  plateTransfer: 'Yes',
  plateNumber: '',
  plateExpiration: '',
  plateType: 'Yes',
  lien: 'No',
  tradeIn: false,
  tradeInVehicleType: undefined,
  tradeInVehicleSubType: undefined,
  tradeInModelYear: undefined,
  purchaseDate: undefined,
  basePrice: undefined,
  tradeInValue: '',
  docFees: '',
  extendedWarranties: undefined,
  addOns: undefined,
  protectionPackages: undefined,
  dealerInventoryTaxes: undefined,
  deliveryFees: '',
  taxesPaidDealerState: undefined,
  dealerServiceFee: undefined,
};

export const QuoteSchemaYup = yup.object().shape({
  status: yup.string().optional(),
  date: yup.string().optional(),
  serviceFormURL: yup.string().url('Must be a valid URL').optional(),
  titleZip: yup.string().optional(),
  titleState: yup.string().optional(),
  county: yup.string().optional(),
  city: yup.string().optional(),
  transactionType: yup.string().optional(),
  collateralType: yup.string().optional(),
  outsideCityLimits: yup.boolean().optional(),
  driverLastName: yup.string().optional(),
  vinNumber: yup.string().optional(),
  commercialUse: yup.string().oneOf(['Yes', 'No']).optional(),
  modelYear: yup.string().optional(),
  make: yup.string().optional(),
  bodyStyle: yup.string().optional(),
  odometer: yup.string().optional(),
  registrationMonths: yup.string().optional(),
  weight: yup.string().optional(),
  registeredWeight: yup.string().optional(),
  gvw: yup.string().optional(),
  gvwr: yup.string().optional(),
  fuelType: yup.string().optional(),
  evTaxCredit: yup.string().oneOf(['Apply credit to taxable amount', 'Do not apply']).optional(),
  taxCreditAmount: yup.string().optional(),
  length: yup.string().optional(),
  activeMilitary: yup.string().oneOf(['Yes', 'No']).optional(),
  mcoTitle: yup.string().oneOf(['MCO', 'Title']).optional(),
  plateTransfer: yup.string().oneOf(['Yes', 'No']).optional(),
  plateNumber: yup.string().optional(),
  plateExpiration: yup.string().optional(),
  plateType: yup.string().oneOf(['Yes', 'Commercial']).optional(),
  lien: yup.string().oneOf(['Yes', 'No']).optional(),
  tradeIn: yup.boolean().optional(),
  tradeInVehicleType: yup.string().optional(),
  tradeInVehicleSubType: yup.string().optional(),
  tradeInModelYear: yup.string().optional(),
  purchaseDate: yup.string().optional(),
  basePrice: yup.string().optional(),
  tradeInValue: yup.string().optional(),
  docFees: yup.string().optional(),
  extendedWarranties: yup.string().optional(),
  addOns: yup.string().optional(),
  protectionPackages: yup.string().optional(),
  dealerInventoryTaxes: yup.string().optional(),
  deliveryFees: yup.string().optional(),
  taxesPaidDealerState: yup.string().optional(),
  dealerServiceFee: yup.string().optional(),
});
